import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ban.svg'


const _hoisted_1 = { class: "pt-8 pb-18 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "py-3 pr-6"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = {
  key: 2,
  class: "py-3 pr-6"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = {
  key: 4,
  class: "py-3 pr-6"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_9 = { class: "flex my-1" }
const _hoisted_10 = { class: "capitalize" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex font-medium text-red-lp-300 mt-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "mr-1",
  src: _imports_0,
  alt: "ban"
}, null, -1)
const _hoisted_14 = { class: "rounded bg-gray-lp-200 text-black-lp-300 p-4 mt-4" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row mt-1"
}
const _hoisted_16 = { key: 4 }
const _hoisted_17 = {
  key: 5,
  class: "py-3"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_DetailPartnerInformation = _resolveComponent("DetailPartnerInformation")!
  const _component_DetailContactInformation = _resolveComponent("DetailContactInformation")!
  const _component_DetailContractInformation = _resolveComponent("DetailContractInformation")!
  const _component_DetailAdditionalInformation = _resolveComponent("DetailAdditionalInformation")!
  const _component_DetailBankInformation = _resolveComponent("DetailBankInformation")!
  const _component_DetailAreaDelivery = _resolveComponent("DetailAreaDelivery")!
  const _component_DetailPosOwnedList = _resolveComponent("DetailPosOwnedList")!
  const _component_DetailRefferalPosInformation = _resolveComponent("DetailRefferalPosInformation")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_QRCodeProfile = _resolveComponent("QRCodeProfile")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_PosBranch = _resolveComponent("PosBranch")!
  const _component_freeze_unfreeze_popup = _resolveComponent("freeze-unfreeze-popup")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_DetailLayout, {
        scrollSidebar: "",
        isTab: 
        _ctx.detailData.partnerType.toLowerCase() === 'pos' &&
          _ctx.detailData.partnerPosType === 'parent' &&
          !_ctx.posId
      ,
        showContent: _ctx.isPosParent,
        customClass: "px-0",
        onBack: _ctx.goBack,
        title: _ctx.getTitle,
        loading: _ctx.isLoading,
        error: _ctx.isError,
        errorType: _ctx.errorCause,
        onTryAgain: _ctx.getDetail
      }, {
        "custom-tab": _withCtx(() => [
          _createVNode(_component_Tabs, {
            data: _ctx.tabs,
            rounded: false,
            modelValue: _ctx.tabActive,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabActive = $event)),
            titleSize: 20,
            marginTop: 1,
            marginBottom: 2
          }, null, 8, ["data", "modelValue"])
        ]),
        data: _withCtx(() => [
          _createVNode(_component_DetailPartnerInformation, {
            detailData: _ctx.detailData,
            districtFieldRules: _ctx.districtFieldRules
          }, null, 8, ["detailData", "districtFieldRules"]),
          _hoisted_2,
          _createVNode(_component_DetailContactInformation, {
            detailData: _ctx.detailData,
            districtFieldRules: _ctx.districtFieldRules
          }, null, 8, ["detailData", "districtFieldRules"]),
          (_ctx.isPos)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPos)
            ? (_openBlock(), _createBlock(_component_DetailContractInformation, {
                key: 1,
                detailData: _ctx.detailData
              }, null, 8, ["detailData"]))
            : _createCommentVNode("", true),
          (_ctx.isPos)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPos)
            ? (_openBlock(), _createBlock(_component_DetailAdditionalInformation, {
                key: 3,
                detailData: _ctx.detailData,
                districtFieldRules: _ctx.districtFieldRules
              }, null, 8, ["detailData", "districtFieldRules"]))
            : _createCommentVNode("", true),
          (!_ctx.posId)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          (!_ctx.posId)
            ? (_openBlock(), _createBlock(_component_DetailBankInformation, {
                key: 5,
                detailData: _ctx.detailData
              }, null, 8, ["detailData"]))
            : _createCommentVNode("", true),
          (this.detailData.partnerType === 'console')
            ? (_openBlock(), _createBlock(_component_DetailAreaDelivery, {
                key: 6,
                detailData: _ctx.detailData
              }, null, 8, ["detailData"]))
            : _createCommentVNode("", true),
          (this.detailData.partnerType === 'console')
            ? (_openBlock(), _createBlock(_component_DetailPosOwnedList, {
                key: 7,
                detailData: _ctx.detailData
              }, null, 8, ["detailData"]))
            : _createCommentVNode("", true),
          _createVNode(_component_DetailRefferalPosInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"])
        ]),
        "sub-data": _withCtx(() => [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posBranch.detail.contractStatus')
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", {
                  class: 
                `rounded-full px-2 py-0 text-center ${
                  _ctx.detailData.partnerContractStatus.toLowerCase() === 'active'
                    ? 'bg-green-lp-300 text-green-lp-200'
                    : _ctx.detailData.partnerContractStatus.toLowerCase() ===
                      'waiting'
                    ? 'bg-yellow-lp-200 text-yellow-lp-100'
                    : _ctx.detailData.partnerContractStatus.toLowerCase() ===
                      'expired'
                    ? 'bg-red-300 text-red-lp-200'
                    : 'bg-yellow-lp-100 text-yellow-200'
                }`
              
                }, [
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.detailData.partnerContractStatus.toLowerCase()), 1)
                ], 2)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.detailData.partnerIsBanned)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('posBranch.detail.partnerStatus')
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_ctx.$t("posBranch.detail.status.freezed")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.detailData.partnerBannedReason), 1)
              ]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('posBranch.detail.partnerStatus'),
                value: "-"
              }, null, 8, ["label"])),
          (_ctx.detailData.partnerType.toLowerCase() === 'pos')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 2,
                label: _ctx.$t('posBranch.detail.balanceAvailable'),
                value: _ctx.convertPartnerBalance,
                "data-testid": "partner-detail-balance-available-value"
              }, null, 8, ["label", "value"]))
            : _createCommentVNode("", true),
          (_ctx.isPos)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 3,
                label: _ctx.$t('posBranch.detail.tierLevel')
              }, {
                default: _withCtx(() => [
                  (_ctx.level?.title)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode("div", null, [
                          _createVNode("img", {
                            src: require(`@/app/ui/assets/svg/level/${_ctx.level?.icon}.svg`),
                            alt: "level"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("div", {
                          class: `pl-2 text-24px font-bold text-${_ctx.level?.color}`
                        }, _toDisplayString(_ctx.level?.title), 3)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (!_ctx.posId && _ctx.isEditAble)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                (_ctx.detailData.partnerIsBanned)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      customClass: "px-12 py-2.5 text-red-lp-100",
                      title: _ctx.$t('posBranch.detail.action.unfreeze'),
                      onClick: _ctx.handleFreezeUnFreeze,
                      iconLeft: "red-border-check",
                      outline: ""
                    }, null, 8, ["title", "onClick"]))
                  : (_openBlock(), _createBlock(_component_LpButton, {
                      key: 1,
                      customClass: "px-12 py-2.5 text-white bg-red-lp-100",
                      title: _ctx.$t('posBranch.detail.action.freeze'),
                      onClick: _ctx.handleFreezeUnFreeze,
                      iconLeft: "ban-white"
                    }, null, 8, ["title", "onClick"]))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.posId && _ctx.isEditAble)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _hoisted_18
              ]))
            : _createCommentVNode("", true),
          (!_ctx.posId && _ctx.isEditAble)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 6,
                customClass: "px-12 py-2.5 text-red-lp-100",
                title: _ctx.$t('posBranch.detail.action.edit'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToEdit(_ctx.$route.params.id))),
                iconLeft: "pencil-alt",
                outline: ""
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _hoisted_19,
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posBranch.detail.createdAt'),
            value: _ctx.convertCreatedAt,
            caption: _ctx.detailData.partnerCreatedBy
          }, null, 8, ["label", "value", "caption"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posBranch.detail.updatedAt'),
            value: _ctx.convertUpdatedAt,
            caption: _ctx.detailData.partnerUpdatedBy
          }, null, 8, ["label", "value", "caption"]),
          _hoisted_20,
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posBranch.detail.qrCode')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpButton, {
                onClick: _ctx.downloadQRCode,
                class: "mt-3 w-48",
                flat: "",
                dense: "",
                iconLeft: "qrcode",
                title: _ctx.$t('posBranch.detail.action.downloadQr'),
                textColor: "gray-lp-600"
              }, null, 8, ["onClick", "title"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_QRCodeProfile, {
            "partner-id": _ctx.detailData.partnerId,
            "partner-name": _ctx.detailData.partnerName,
            "partner-address": _ctx.detailData.partnerAddress,
            ref: "qrcodeProfile"
          }, null, 8, ["partner-id", "partner-name", "partner-address"])
        ]),
        _: 1
      }, 8, ["isTab", "showContent", "onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
      (!_ctx.isPosParent)
        ? (_openBlock(), _createBlock(_component_PosBranch, {
            key: 0,
            showHeader: false,
            posParentId: _ctx.id
          }, null, 8, ["posParentId"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.freezeUnFreezeModal)
      ? (_openBlock(), _createBlock(_component_freeze_unfreeze_popup, _mergeProps({
          key: 0,
          onFinish: _ctx.getDetail,
          modelValue: _ctx.freezeUnFreezeModal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.freezeUnFreezeModal = $event))
        }, _ctx.partnerSelected), null, 16, ["onFinish", "modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}